import { creationCommonStyle, settingsCommonStyles } from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';
import { uurlTestToolStyle, convertToLocalStyle, glyphIconStyle } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = (_, core) => ({
  urlOptionsContainer: {
    ...creationCommonStyle(core),
    ...settingsCommonStyles(core),
    ...uurlTestToolStyle(core),
    ...convertToLocalStyle(glyphIconStyle(core)),
    marginLeft: '-15px',
    backgroundColor: `${core && core.palette && core.palette.white}`,
    '& .control-label': {
      marginTop: 0,
    },
    // private\ui-next\packages\settings-page\src\styles\custom-params.js
    '& #customParametersSettings': {
      '& .custom-param__key-field': {
        width: '155px',
        display: 'inline-block',
      },
      '& .closeimage.custom-param__close-button': {
        position: 'static',
      },
      '& .custom-param__value-field': {
        width: '260px',
        display: 'inline-block',
      },
      '& .custom-param-entry': {
        '& .control-label': {
          display: 'inline-block',
        },
        '& input.form-control': {
          display: 'inline-block',
        },
        '& label.control-label': {
          display: 'inline-block',
          marginLeft: '5px',
          marginRight: '5px',
        },
      },
      '& .custom-param__key-container': {
        display: 'inline-block',
      },
      '& .flex-row-dynamic': {
        verticalAlign: 'initial',
      },
    },
    // private\ui-next\packages\top-grid-panel\src\upgraded-url-override-style.js
    '& .custom-params-template .custom-param-entry': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .custom-params-template .custom-param-entry td': {
      display: 'flex',
      alignItems: 'baseline',
    },
    '& .custom-params-template .flex-row-fixed.custom-param__key-container': {
      display: 'flex',
      alignItems: 'baseline',
    },
    '& .custom-params-template .flex-row-fixed.custom-param__key-container .control-label': {
      whiteSpace: 'pre',
    },
    '& .custom-params-template .flex-row-fixed.custom-param__key-container input.form-control.custom-param__key-field': {
      margin: '0px 5px',
    },
    '& .custom-params-template .flex-row-dynamic input.form-control.custom-param__value-field': {
      marginLeft: '5px',
    },
    '& .custom-params-template .closeimage.custom-param__close-button': {
      height: '20px',
      display: 'flex',
      alignItems: 'center',

      '&:before': {
        fontFamily: '"MsAds MDL2 Assets"',
        content: '"\\E711"',
      },
    },
    '& .custom-param__close-button': {
      marginLeft: 10,
      cursor: 'pointer',
    },
    // hotel campaign  new ui
    '& .tracking-template,& .final-url-suffix , & .custom-parameters': {
      width: 'auto',
      marginLeft: '-15px',
    },
    '& .tracking-template .form-control, & .final-url-suffix .form-control': {
      width: '435px',
    },
    '& span.is-error, & .font-error': {
      color: `${core.semanticColors && core.semanticColors.errorIcon}`,
    },
    '& .helpbutton': {
      marginRight: '5px',
    },
  },
});

